import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  customerActions,
  httpRequestsOnSuccessActions,
  loadActions,
  loadAuthActions,
  mcActions,
  officeActions,
} from 'store';
import {
  CsvFile,
  DateFilters, DateSelector,
  FullTable,
  PriceConvertor,
  SelectActions,
  TableWrapper,
  UserInputsDropdown,
} from 'components';
import {
  FindSuccessItem, isAdmin, isFactored,
  PermissionsList,
  RolePermission,
  SavePage,
  useGlobalStyles,
  useModal,
  usePrimaryModal,
} from 'utils';
import {
  ACTION_TYPE,
  PmtPendingEnums,
  RECEIVABLE,
  receivablesBody,
  receivablesCsv,
  receivablesHead,
} from '../constants';
import { TotalItems } from './core/totalItems';
import { ReceivablesNoteDrawer } from './receivablesNote';
import { LoadDetailSwitcher, RENDER_LOADS } from '../../loads';

const SET_AS_DEBT = 'SET_AS_BAD_DEBT';
export const BadDebt = ({}) => {
  const { loadsList, receivablesInfo, customersList, mcsList, officesList, receivableCustomersForSelect } = useSelector((state) => ({
    loadsList: state.loads.loadsList,
    receivablesInfo: state.loads.receivablesInfo,
    customersList: state.customers.customersList,
    mcsList: state.mcs.mcsList,
    officesList: state.offices.officesList,
    receivableCustomersForSelect: state.loads.receivableCustomersForSelect,
  }));
  const dispatch = useDispatch();
  const classes = useGlobalStyles();
  const history = useHistory();
  const info = history?.location?.state;
  const [currentId, setCurrentId] = useState({});
  const { open } = useModal();
  const { openPrimary } = usePrimaryModal();
  const renderLoads = FindSuccessItem(RENDER_LOADS);
  const setAsSuccess = FindSuccessItem(SET_AS_DEBT);
  const receivableParams = {
    ...receivablesCsv,
    // customer: info?.customer,
    customerForSelect: true,
    mc: info?.mc,
    isBadDebt: true,
    title: 'Receivables CSV',
    noDesc: true,
  };
  const [selectedList, setSelectedList] = useState([]);

  useEffect(() => {
    if (isAdmin) {
      dispatch(customerActions.getCustomers({ status: 'ACTIVE' }));
      dispatch(mcActions.getMcs());
      dispatch(officeActions.getOffices());
    } else {
      dispatch(loadActions.getReceivableCustomersForSelect({ isBadDebt: true }));
    }
  }, []);

  const renderParams = () => {
    const filteredInfo = {
      ...info,
      isBadDebt: true,
    };
    filteredInfo.skip = info?.skip ? info?.skip : 0;
    filteredInfo.limit = 100;

    if (info?.pmtPending) {
      filteredInfo.pmtPending = info?.pmtPending === PmtPendingEnums.PMT_PENDING;
    } else {
      delete filteredInfo.pmtPending;
    }
    delete filteredInfo.page;
    delete filteredInfo.activeTab;
    return filteredInfo;
  };

  useEffect(() => {
    handleGet('loading');
    const interval = setInterval(() => {
      handleGet('noLoad');
    }, 30000);
    return () => clearInterval(interval);
  }, [info]);

  useEffect(() => {
    if (renderLoads) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(RENDER_LOADS));
      handleGet('noLoad');
    }
    if (setAsSuccess) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(SET_AS_DEBT));
      handleGet('noLoad');
      setSelectedList([]);
    }
  }, [renderLoads, setAsSuccess]);

  const handleGet = (loading) => {
    const loader = loading === 'loading' ? 'loading' : 'noLoad';
    const filteredInfo = renderParams();
    const receivablesInfo = renderParams();
    delete receivablesInfo.skip;
    delete receivablesInfo.limit;
    delete receivablesInfo.department;
    dispatch(loadActions.getReceivablesInfo(receivablesInfo));
    dispatch(loadActions.getLoadsByStatus({ ...filteredInfo, department: RECEIVABLE }, loader));
  };

  const handleSubmit = async (info, name) => {
    if (name === 'verify') {
      setCurrentId({ id: info.id, name: 'verify' });
      try {
        await loadAuthActions.verifyBilling(info.id);
        handleGet('noLoad');
      } finally {
        setCurrentId({});
      }
    }
    if (name === 'pmtPending') {
      setCurrentId({ id: info.id, name: 'pmtPending' });
      try {
        await loadAuthActions.pmtPending(info.id, !info?.pmtPending);
        handleGet('noLoad');
        dispatch(httpRequestsOnSuccessActions.appendSuccess('PMT_PENDING'));
      } finally {
        setCurrentId({});
      }
    }
  };

  const pushPageDetails = (id) => {
    openPrimary(<LoadDetailSwitcher loadId={id} />);
    // history.push({
    //   pathname: `/load/${id}`,
    //   state: { loadParams: { ...info }, parent: '/receivables', detail: 'billing' },
    // });
  };

  const handleChange = (value, name) => {
    const params = {
      ...info,
    };
    params.skip = 0;
    params.limit = 100;
    params.page = 1;
    if (value) {
      params[name] = value.id;
    } else {
      delete params[name];
    }
    SavePage(history, info, { ...params });
  };

  const handleCheck = (ev, item, name) => {
    ev.stopPropagation();
    ev.preventDefault();
    if (name === 'selectAll') {
      let allList = loadsList?.loads?.map((i) => i?.id);
      setSelectedList(allList);
    } else {
      if (name === 'all') {
        let allList = loadsList?.loads?.length === selectedList?.length ? [] : loadsList?.loads?.map((i) => i?.id);
        setSelectedList(allList);
      } else {
        const list = [...selectedList];
        const uniqSet = new Set(list);
        if (!uniqSet.has(item?.id)) {
          list.push(item?.id);
        } else {
          list.indexOf(item?.id) !== -1 && list.splice(list.indexOf(item?.id), 1);
        }
        setSelectedList(list);
      }
    }
  };

  const removeSelectedList = () => {
    setSelectedList([]);
  };

  const afterSuccess = () => {
    handleGet('noLoad');
  };

  return (
    <div>
      <div className={classes.filtersWrapper}>
        <div className="align-center">
          {/*<DateFilters status={RECEIVABLE} />*/}
          <div style={{ marginRight: 16 }}>
            <DateSelector
              startName={'from'}
              endName={'to'}
            />
          </div>
          {isAdmin &&
            <>
              <ReceivablesNoteDrawer />
              <UserInputsDropdown
                dropdownOptions={customersList?.customers}
                onPass={(option) => handleChange(option, 'customer')}
                selected={info?.customer ? info?.customer : ''}
                noText={'All Customers'}
                firstText={'name'}
              />
              <UserInputsDropdown
                dropdownOptions={mcsList?.mcs}
                onPass={(option) => handleChange(option, 'mc')}
                selected={info?.mc ? info?.mc : ''}
                noText={'All Authority'}
                firstText={'name'}
                renderOption={(option) => <div>
                  <p style={{ fontSize: 16, color: '#2A374E' }}>{option?.name}</p>
                  {option?.biller && <p style={{
                    fontSize: 14,
                    color: '#9C9EA9',
                    marginTop: 4,
                  }}>{`${option?.biller?.firstName} ${option?.biller?.lastName}`}</p>}
                </div>}
              />
              <UserInputsDropdown
                dropdownOptions={officesList?.offices}
                onPass={(option) => handleChange(option, 'office')}
                selected={info?.office ? info?.office : ''}
                noText={'All Offices'}
                firstText={'name'}
              />
            </>
          }
          {!isAdmin &&
          <>
            <UserInputsDropdown
              dropdownOptions={receivableCustomersForSelect}
              onPass={(option) => handleChange(option, 'customer')}
              selected={info?.customer ? info?.customer : ''}
              noText={'All Customers'}
              firstText={'name'}
            />
          </>
          }
        </div>
        {(RolePermission([PermissionsList?.ALL_ACCESS?.code, PermissionsList?.EXPORT_RECEIVABLE_CSV?.code], 'officeManager') || isFactored) &&
          <CsvFile params={receivableParams} />
        }
      </div>

      <TableWrapper
        buttonsTab={true}
        link={true}
        tab={'none'}
        buttonsTabAddButton={false}
      >
        <div className={classes.totalWrapper}>
          <div className={classes.centerItem}>
            <p className={classes.totalTitle}>Totals</p>
            <div className={classes.receivablesTotalsBox}></div>
          </div>
          <div>
            <TotalItems
              text={<PriceConvertor price={receivablesInfo?.grandTotal?.amount} />}
              count={` (${receivablesInfo?.grandTotal?.count || 0})`}
              title={'Total: '}
              color={'#E6ECF380'}
              styles={{ marginRight: 0 }}
            />
          </div>
        </div>
        {
          RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.VERIFY_RECEIVABLES?.code]) &&
          !!selectedList?.length &&
          <SelectActions
            submitText={'Unmark as Bad Debt'}
            actionType={SET_AS_DEBT}
            selectedList={selectedList?.length}
            selectAll={handleCheck}
            submitClaims={() => dispatch(loadActions.setAsBadDept({ loadIds: selectedList, isBadDebt: false }))}
            removeSelected={removeSelectedList}
            submitWidth={'170px'}
          />
        }
        <FullTable
          head={receivablesHead(handleCheck, loadsList?.loads, selectedList)}
          body={receivablesBody(open, currentId, handleCheck, loadsList?.loads, selectedList, afterSuccess)}
          loadingType={ACTION_TYPE}
          list={loadsList?.loads}
          listCount={loadsList?.count}
          handleClick={pushPageDetails}
          noText={'Receivables'}
          handleClickButton={handleSubmit}
        />
      </TableWrapper>
    </div>
  );
};